import {
  FormikSpinButton,
  FormikTextField,
} from 'formik-office-ui-fabric-react'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import { Proving } from 'model'
import { Label } from 'office-ui-fabric-react'
import { Position } from 'office-ui-fabric-react/lib/utilities/positioning'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

export type ProvingDetailsUnknownVehicleFormValues = Proving
export class ProvingDetailsUnknownVehicleFormSchema {
  constructor() {
    return Yup.object().shape({
      amount: Yup.number().required(),
      model: Yup.string().required(),
    })
  }
}

export const ProvingDetailsUnknownVehicleForm: React.FunctionComponent = () => {
  const { t } = useTranslation()

  return (
    <FormStack>
      <Label>{t('field.vehicle.addUnknownVehicles')}</Label>
      <FieldStackItem
        name={'amount'}
        render={(fieldProps) => (
          <FormikSpinButton
            label={t('field.amount.label')}
            labelPosition={Position.top}
            max={10}
            min={1}
            {...fieldProps}
          />
        )}
      />
      <FieldStack>
        <Label>{t('field.vehicle.vehicleModel')}</Label>
        <FieldStackItem name="model" component={FormikTextField} />
      </FieldStack>
    </FormStack>
  )
}
